import { defineMessages } from 'react-intl-next';

// TODO: sync with content designer
export const messages = defineMessages({
	actionsForRotation: {
		id: 'eoc-schedule.ui.list.edit-schedule.sidebar.list-rotation.actions-for-rotation.options',
		defaultMessage: 'Actions for rotation {rotationName}',
		description: 'Label of a button for opening rotation options dropdown',
	},
});
